import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
type CompareState = {
  items: string[];           // compared property ids
  max: number;               // optional limit (e.g., 10)
  add: (id: string) => void;
  remove: (id: string) => void;
  toggle: (id: string) => void;
  clear: () => void;
};

const noopStorage: Storage = {
  getItem: () => null,
  setItem: () => { },
  removeItem: () => { },
  key: () => null,
  length: 0,
};

export const useCompareStore = create<CompareState>()(
  persist(
    (set, get) => ({
      items: [],
      max: 10,
      add: (id) =>
        set((state) => {
          if (state.items.includes(id)) return state;
          if (state.items.length >= state.max) return state; // enforce max limit
          return { items: [...state.items, id] };
        }),
      remove: (id) =>
        set((state) => ({ items: state.items.filter((x) => x !== id) })),
      toggle: (id) => {
        const { items } = get();
        if (items.includes(id)) {
          get().remove(id);
        } else {
          get().add(id);
        }
      },
      clear: () => set({ items: [] }),
    }),
    {
      name: "comparedProperties",
      storage: createJSONStorage(() =>
        typeof window !== "undefined" ? localStorage : noopStorage
      ),
      partialize: (state) => ({ items: state.items, max: state.max }),
    }
  )
);

// Optional: cross-tab sync (keeps count in sync across browser tabs)
if (typeof window !== "undefined") {
  const key = "comparedProperties";
  window.addEventListener("storage", (e) => {
    if (e.key === key) {
      try {
        const parsed = e.newValue ? JSON.parse(e.newValue) : null;
        const items = parsed?.state?.items ?? [];
        useCompareStore.setState({ items });
      } catch {
        // ignore
      }
    }
  });
}